import { render, staticRenderFns } from "./ConsultaInstalacionesBase.vue?vue&type=template&id=2d3ca2c3&"
import script from "./ConsultaInstalacionesBase.vue?vue&type=script&lang=ts&"
export * from "./ConsultaInstalacionesBase.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultaInstalacionesBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports